import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from '../enTranslations';
import arTranslations from '../arTranslation';



i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: enTranslations,
        },
        ar: {
            translation: arTranslations,
        },
    },
    lng: 'en', // default language
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
